export default __webpack_public_path__ + "static/media/doctors_in_war_2.84fa9d7e.png";